import {Product} from "@app/core/product/domain/dtos/product";
import {ProductDetails} from "@app/core/product/domain/dtos/product-details";
import {ProductListPage} from "@app/core/product/domain/dtos/product-list-page";
import {ProductSearchSuggestion} from "@app/core/product/domain/dtos/product-search-suggestion";
import {Observable} from "rxjs";
import {ProductFilter} from "../dtos/product-filter";

export abstract class ProductRemote {
    public abstract getSearchSuggestions(query: string): Observable<ProductSearchSuggestion[]>;
    public abstract getProductDetails(productCode: string): Observable<ProductDetails>;
    public abstract getProductByEan(productEan: string): Observable<ProductDetails>;
    public abstract getSimilarProducts(productCode: string, itemsPerPage: number, page: number): Observable<Product[]>;
    public abstract getSuggestedProducts(deliveryPointCode: number): Observable<Product[]>;
    public abstract getProductList(itemsPerPage: number, page: number, selectedFilters: string, selectedSorting: string,
        categoryCode: string, specialTypeCode: string, query: string): Observable<ProductListPage>;
    public abstract getFilters(selectedFilters: string, categoryCode: string, specialTypeCode: string, query: string): Observable<ProductFilter[]>;
}
